import { createContext } from 'react';

import { ProjectHealthResponse } from '@totem/components/ticketing/projectsDashboard/types';

interface Context {
  loading: boolean;
  data: ProjectHealthResponse | null;
}

const defaultValue: Context = {
  loading: true,
  data: null,
};

const ProjectsDashboardContext = createContext<Context>(defaultValue);

export default ProjectsDashboardContext;
